import { render, staticRenderFns } from "./AssetPoolDistributionDetailsView.vue?vue&type=template&id=18531fe5&scoped=true&"
import script from "./AssetPoolDistributionDetailsView.vue?vue&type=script&lang=js&"
export * from "./AssetPoolDistributionDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./AssetPoolDistributionDetailsView.vue?vue&type=style&index=0&id=18531fe5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18531fe5",
  null
  
)

export default component.exports